import { useCallback, useEffect, useState } from 'react'

import { WidgetChoice } from '@/common/util/choice'

export const useSelectIds = (models: { id: number }[], condition: Record<string, any>) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([])

  const onSelectId = (id: number) => {
    setSelectedIds((selectedIds) =>
      selectedIds.includes(id) ? selectedIds.filter((selectId) => selectId != id) : [...selectedIds, id]
    )
  }

  const onSelectAll = useCallback(
    (checked: boolean) => {
      setSelectedIds(checked ? models.map((model) => model.id) : [])
    },
    [models]
  )

  useEffect(() => {
    setSelectedIds([])
  }, [condition])

  return { selectedIds, setSelectedIds, onSelectId, onSelectAll }
}

export const booleanSelectName = (value: boolean) => {
  return value ? 'あり' : 'なし'
}

export const booleanSelectChoices: WidgetChoice<boolean>[] = [
  {
    name: 'あり',
    value: true
  },
  {
    name: 'なし',
    value: false
  }
]

export const booleanSelectChoicesTF: WidgetChoice<boolean>[] = [
  {
    name: 'TRUE',
    value: true
  },
  {
    name: 'FALSE',
    value: false
  }
]
